<template>
  <div class="container mx-auto my-8 px-4 md:px-0">
    <base-form v-if="user" :do="save" :v-errors="error" class="flex flex-col md:flex-row md:-mx-4">

      <div class="w-full bg-white content shadow mb-6 md:mb-0 md:mx-4 md:w-2/3">
        <div class="group">
          <div class="caption">
            <h5 class="text-base font-semibold font-medium text-green-dark">Account</h5>
          </div>
          <div class="fields flex flex-col w-full p-6">
            <div class="flex flex-wrap mx-0 md:-mx-2">
              <text-input class="w-full md:w-1/2 md:px-2" v-model="user.name" label="Naam" name="name" type="text" v-validate="'required|alpha_spaces'" data-vv-as="Naam"
                :error="errors.first('name')" :has-permission="true" :required="true"></text-input>

              <text-input class="w-full md:w-1/2 md:px-2 mb-4" v-model="user.email" label="E-mailadres" name="email" type="email" v-validate="'required|email'" data-vv-as="E-mailadres"
                :error="errors.first('email')" :has-permission="true" :required="true"></text-input>
            </div>

            <div class="flex flex-wrap mx-0 md:-mx-2">
              <password-input class="w-full md:px-2" v-model="user.password" label="Wachtwoord" v-validate="{ 'required': isNew }"
                :error="passwordError" :has-permission="true" :required="isNew"></password-input>
            </div>

            <div class="flex flex-wrap w-full mt-8" v-if="isNew">
              <label class="inline-block font-semibold mb-4">
                <input class="mr-2 leading-tight" type="checkbox" v-model="user.notify_by_email">
                <span class="text-xs">Stel gebruiker op de hoogte.</span>
              </label>
            </div>
          </div>
        </div>
        <div class="group">
          <div class="caption">
            <h5 class="text-base font-semibold font-medium text-green-dark">Gebruikersgroepen</h5>
          </div>
          <div class="w-full">
            <ul class="list-reset w-full">
              <li v-for="(value, index) in roles" :key="value.id">
                <label :class="{ 'border-t': index != 0 }" class="inline-block border-grey-lighter flex justify-between py-4 pl-6 pr-6 cursor-pointer hover:bg-grey-lightest">
                  <span class="text-xs">{{ value.name }}</span>
                  <input class="leading-tight" type="checkbox" :value="value.name" v-model="user.roles">
                </label>
              </li>
            </ul>
          </div>
        </div>
        <div class="flex w-full px-6 py-6 bg-grey-lightest border-t border-grey-lighter flex items-center">
          <button v-if="!isNew" tabindex="-1" type="button" class="text-sm text-red hover:underline" @click="destroy()">
            <span>Verwijder</span>
            <span class="hidden md:inline ml-1">Gebruiker</span>
          </button>
          <button type="submit" class="btn py-3 text-sm text-white bg-green-dark font-semibold ml-auto">
            <span>{{ isNew ? 'Bewaren' : 'Wijzig' }}</span>
            <span class="hidden md:inline ml-1">Gebruiker</span>
          </button>
        </div>
      </div>

      <div class="flex flex-col w-full z-0 md:mx-4 md:w-1/3">
        <!-- CREATED -->
        <div class="w-full mb-4 shadow" style="background-color: #e7eef3;" v-if="user.created_at">
          <div class="field w-full px-4 pt-4 pb-2">
            <div class="heading mb-2">
              <label class="uppercase tracking-wide text-xs text-grey-dark font-bold" for="">Gemaakt op</label>
            </div>
            <div class="input">
              <span class="block w-full text-sm text-grey-darkest">{{ user.created_at }}</span>
            </div>
          </div>
          <div class="field w-full px-4 py-2 pt-2 pb-4">
            <div class="heading mb-2">
              <label class="uppercase tracking-wide text-xs text-grey-dark font-bold" for="">Gewijzigd op</label>
            </div>
            <div class="input">
              <span class="block w-full text-sm text-grey-darkest">{{ user.updated_at }}</span>
            </div>
          </div>
        </div>
      </div>

    </base-form>
  </div>
</template>

<script>
import UserService from '@/services/user';
import UserPerimeters from '@/perimeters/user';
import BaseForm from '@/components/globals/BaseForm';
import TextInput from '@/components/inputs/Text';
import PasswordInput from '@/components/inputs/Password';
import SelectInput from '@/components/inputs/Select';

export default {
  name: 'UserEdit',
  perimeters: [UserPerimeters],
  $_veeValidate: {
    validator: 'new'
  },
  components: {
    BaseForm,
    TextInput,
    PasswordInput,
    SelectInput
  },
  data() {
    return {
      user: {
        notify_by_email: false,
        contact_id: this.$route.params.id,
        roles: []
      },
      roles: null,
      role: null,
      isNew: false,
      error: null
    };
  },
  created() {
    this.fetchUser();
    this.fetchRoles();
  },
  computed: {
    passwordError() {
      if (this.errors.first('Wachtwoord')) {
        return this.errors.first('Wachtwoord');
      }

      return this.error && this.error.details && this.error.details.password
        ? this.error.details.password[0]
        : null;
    }
  },
  methods: {
    selectboxChanged(option) {
      this.user.role_id = option ? option.id : null;
    },
    async fetchUser() {
      if (!this.$route.params.user_id) {
        return (this.isNew = true);
      }

      try {
        const response = await UserService.get(this.$route.params.user_id);
        this.user = { ...this.user, ...response.data.data };
        this.user.notify_by_email = false;
      } catch (error) {
        this.error = error.data;
        this.user = null;
      }
    },
    async fetchRoles() {
      try {
        const response = await UserService.roles();
        this.roles = response.data.data;
      } catch (error) {
        this.error = error.data;
        this.roles = null;
      }
    },
    async save() {
      try {
        await UserService.save(this.user.id, this.user);

        return this.$router.push({
          name: 'organization',
          params: { id: this.user.contact_id }
        });
      } catch (error) {
        this.error = error.data;
      }
    }
  }
};
</script>
